import { render, staticRenderFns } from "./BitdefenderReport.vue?vue&type=template&id=23f408f2&"
import script from "./BitdefenderReport.vue?vue&type=script&lang=js&"
export * from "./BitdefenderReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports